import { render, staticRenderFns } from "./DepartmentRoleUserProfile.vue?vue&type=template&id=305780e9&"
import script from "./DepartmentRoleUserProfile.vue?vue&type=script&lang=js&"
export * from "./DepartmentRoleUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentRoleUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports